import { z } from 'zod';
export const subscriptionSaleTypeSchema = z.enum(['NewSale', 'Prolongation', 'Migration']);
export const SubscriptionSaleType = subscriptionSaleTypeSchema.enum;
